import React from 'react'
import { components } from 'react-select'

const DefaultMultiValueLabel = (props) => <components.MultiValueLabel {...props} />

export { DefaultMultiValueLabel }
